export const InputArea = ({ onChange, ...args }) => {
  return (
    <div>
      <textarea style={{width:327, height:119, borderRadius:10}} onChange={(e) => onChange(e.target.value)} {...args} />
    </div>
  );
};
